import React from "react";
import throttle from "lodash/throttle";

function OnScreen(WrappedComponent) {
    class OnScreenWrapper extends React.PureComponent {
        state = {
            onScreen: false
        };

        isElementInViewport = el => {
            const rect = el.getBoundingClientRect();
            const windowHeight =
                (typeof window !== "undefined" && window.innerHeight) ||
                (document && document.documentElement.clientHeight);
            const windowWidth =
                (typeof window !== "undefined" && window.innerWidth) ||
                (document && document.documentElement.clientWidth);

            // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
            const vertInView =
                rect.top <= windowHeight && rect.top + rect.height >= 0;
            const horInView =
                rect.left <= windowWidth && rect.left + rect.width >= 0;

            return vertInView && horInView;
        };

        scrollHandler = throttle(() => {
            if (this.unmounting || !this.component) {
                return;
            }

            if (this.isElementInViewport(this.component)) {
                this._isInViewport();
            }
        }, 300);

        componentDidMount() {
            this.unmounting = false;

            window.addEventListener(
                "OnScreenTrigger",
                this.scrollHandler,
                true
            );
            window.addEventListener("scroll", this.scrollHandler, true);
            // Make scroll handler run before scrolling starts in order to show elements already on the screen
            this.scrollHandler();

            if (window.matchMedia) {
                var mediaQueryList = window.matchMedia("print");
                mediaQueryList.addListener(mql => {
                    if (mql.matches && !this.state.onScreen) {
                        this._isInViewport();
                    }
                });
            }

            window.onbeforeprint = () =>
                !this.state.onScreen && this._isInViewport();
        }

        componentWillUnmount() {
            this.unmounting = true;
            if (typeof window !== "undefined") {
                window.removeEventListener("scroll", this.scrollHandler);
                window.removeEventListener(
                    "OnScreenTrigger",
                    this.scrollHandler,
                    true
                );
            }
        }

        _isInViewport = () => {
            this.setState({ onScreen: true });
            window.removeEventListener("scroll", this.scrollHandler, true);
            window.removeEventListener(
                "OnScreenTrigger",
                this.scrollHandler,
                true
            );
        };

        render() {
            return (
                <span ref={s => (this.component = s)}>
                    <WrappedComponent
                        onScreen={this.state.onScreen}
                        {...this.props}
                    />
                </span>
            );
        }
    }

    const {
        onScreen, // eslint-disable-line no-unused-vars
        ...propTypes
    } = WrappedComponent.propTypes;

    if (WrappedComponent.propTypes) {
        OnScreenWrapper.propTypes = propTypes;
    }
    if (WrappedComponent.themes) {
        OnScreenWrapper.themes = WrappedComponent.themes;
    }
    if (WrappedComponent.gradients) {
        OnScreenWrapper.gradients = WrappedComponent.gradients;
    }

    return OnScreenWrapper;
}

export default OnScreen;



// WEBPACK FOOTER //
// ./src/components/OnScreen/OnScreen.jsx